$('#heading .menu-toggle, #sidebar-backdrop').click(function() {
  $('#wrapper').toggleClass('open');
});
